import React from "react"
import { Box } from "@chakra-ui/layout"

interface Props {
    pattern?: string
}

export default function TestimonialBackground({ pattern }: Props) {
    return (
        <>
            <Box
                position="absolute"
                left={0}
                top={0}
                right={0}
                bottom={0}
                bg="blackAlpha.100"
                clipPath="circle(50% at 0 50%)"
            >
                <Box
                    position="absolute"
                    left={0}
                    right={0}
                    top={0}
                    bottom={0}
                    bgImage={pattern}
                />
            </Box>
            <Box
                position="absolute"
                left={0}
                top={0}
                right={0}
                bottom={0}
                bg="blackAlpha.100"
                clipPath="circle(75% at 0 50%)"
            />
        </>
    )
}
